// Auto-generated from proto definitions. DO NOT EDIT.

export type VatType = 'VAT_TYPE_UNSPECIFIED' | 'VAT_TYPE_NONE' | 'VAT_TYPE_0' | 'VAT_TYPE_5' | 'VAT_TYPE_7' | 'VAT_TYPE_10' | 'VAT_TYPE_20' | 'VAT_TYPE_22' | 'VAT_TYPE_10_110' | 'VAT_TYPE_20_120' | 'VAT_TYPE_22_122';

export const VatTypeValues = ['VAT_TYPE_UNSPECIFIED', 'VAT_TYPE_NONE', 'VAT_TYPE_0', 'VAT_TYPE_5', 'VAT_TYPE_7', 'VAT_TYPE_10', 'VAT_TYPE_20', 'VAT_TYPE_22', 'VAT_TYPE_10_110', 'VAT_TYPE_20_120', 'VAT_TYPE_22_122'] as const;
